export class Populator {

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
